
import { authSelectors } from 'ducks/auth'
import Tooltip from 'elements/tooltip/Tooltip'
import { useParsedContactData } from 'hooks/useParsedContactData'
import CustomerBadgeTooltipContent from 'projectSections/sections/manage3/common/CustomerBadgeTooltipContent'
import { useMemo } from 'react'
import type { ContactType } from 'types/contacts'

import { makeStyles } from 'opensolar-ui'
const useStyles = makeStyles({
  tooltip: {
    backgroundColor: 'white !important',
    padding: '10px 0px 5px 0px',
    minWidth: '255px',
    top: 8,
  },
})
export const ContactsBlock = ({ contactsData }: { contactsData: ContactType[] | undefined }) => {
  const classes = useStyles()
  const parsedContacts = useParsedContactData(contactsData)
  const firstContact = useMemo(() => (!!parsedContacts?.length ? parsedContacts[0] : undefined), [parsedContacts])
  const hasContactInfo = (contact) => {
    return contact?.email || contact?.phone
  }
  const shouldShowTooltip = hasContactInfo(firstContact)
  if (!contactsData || contactsData?.length === 0 || firstContact?.type === 1) {
    return <div>－</div>
  }
  if (firstContact)
    return (
      <Tooltip
        title={shouldShowTooltip ? <CustomerBadgeTooltipContent activeContactInfo={firstContact} /> : ''}
        interactive={true}
        classes={{ tooltip: classes.tooltip }}
      >
        <div style={{ color: '#1890ff' }}>{firstContact.display}</div>
      </Tooltip>
    )
  return <div>－</div>
}
